import { register } from "./registry";

/**
 * Print template editor (Backoffice ▸ Print Templates ▸ Edit).
 *
 *   <textarea id="template-json" data-tpl-source>          the template text (the designer writes it too)
 *   <form data-tpl-preview> <input type="hidden" name="Json">  posts the unsaved text to the preview frame
 *   <button data-tpl-preview-now>                           draws the preview
 *   <button data-tpl-insert="{{field}}">                    inserts a field at the cursor
 *   <button data-tpl-tab="designer|advanced">               switches between the designer and [data-tpl-advanced]
 *
 * The preview is drawn when the page opens and again shortly after every change to the text.
 */
register((root) => {
  const source = root.querySelector<HTMLTextAreaElement>("textarea[data-tpl-source]");
  const preview = root.querySelector<HTMLFormElement>("form[data-tpl-preview]");
  if (!source || !preview || preview.dataset.tplBound === "1") return;
  preview.dataset.tplBound = "1";

  preview.addEventListener("submit", () => {
    const json = preview.querySelector<HTMLInputElement>("input[name=Json]");
    if (json) json.value = source.value;
  });
  root.querySelectorAll<HTMLButtonElement>("[data-tpl-preview-now]").forEach((b) =>
    b.addEventListener("click", () => preview.requestSubmit()));
  root.querySelectorAll<HTMLButtonElement>("[data-tpl-insert]").forEach((chip) =>
    chip.addEventListener("click", () => {
      const at = source.selectionStart ?? source.value.length;
      source.setRangeText(chip.dataset.tplInsert ?? "", at, source.selectionEnd ?? at, "end");
      source.dispatchEvent(new Event("input", { bubbles: true }));
      source.focus();
    }));

  let timer = 0;
  source.addEventListener("input", () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => preview.requestSubmit(), 700);
  });

  const tabs = Array.from(root.querySelectorAll<HTMLButtonElement>("[data-tpl-tab]"));
  const show = (tab: HTMLButtonElement) => {
    const advanced = tab.dataset.tplTab === "advanced";
    tabs.forEach((t) => { t.classList.toggle("active", t === tab); t.setAttribute("aria-selected", String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
    root.querySelectorAll<HTMLElement>("[data-tpl-advanced]").forEach((el) => { el.hidden = !advanced; });
    const designer = root.querySelector<HTMLElement>("[data-tpl-designer]");
    if (designer) designer.hidden = advanced;
    (advanced ? source : designer?.querySelector<HTMLElement>("[role=tree], .tpl-pz-paper"))?.focus();
  };
  tabs.forEach((t) => {
    t.addEventListener("click", () => show(t));
    t.addEventListener("keydown", (e) => {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      const next = tabs[(tabs.indexOf(t) + (e.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length];
      if (next) show(next);
    });
  });

  preview.requestSubmit();
});
